import {Storage} from "@/Services/Storage";

export default {
    name : `requests`,
    state: {
        requests : 0,
        kazangRequests : 0,
    },
    getters: {
        getTotalRequestCount:(state)=>{
          return state.kazangRequests + state.requests;
        },

        getClientRequestCount:(state)=>{
          return state.requests;
        },

        getAgentRequestCount:(state)=>{
          return state.kazangRequests;
        },
    },
    mutations: {
        setRequestCounts:(state , payload) => {
          state.requests = payload.requestCount;
          state.kazangRequests = payload.agentCount;
        },
    },
    actions: {
        getRequestCounts:(context)=>{
            let userID = Storage.getAgentID();
            if (!userID) return;
            let currentCount = context.getters.getTotalRequestCount;
            console.log({currentCount})
            return axios.get(bankApi+`bankAgents/countAllRequests?AgentID=`+userID)
                .then(({data}) => {
                    context.commit(`setRequestCounts`, data.response)
                    let updatedCount = context.getters.getTotalRequestCount;
                    return updatedCount > currentCount;
                }).catch(err=>errorHandler.tomcatError(err))
        },
        getAllPendingRequests:() => {
            let userID = Storage.getAgentID();
            return axios.get(bankApi+`bankAgents/getAllPending?AgentID=`+userID)
                .then(({data}) => data.response).catch(err=>errorHandler.tomcatError(err))
        },
        getAllPendingAgentRequests:() => {
            let userID = Storage.getAgentID();
            return axios.get(bankApi+`bankAgents/getAgentSignUpRequests?AgentID=`+userID)
                .then(({data}) => data.response).catch(err=>errorHandler.tomcatError(err))
        },
        getClientDataByID : (context , headerID) =>{
            return axios.get(bankApi+`signup/signupData?id=`+headerID)
                .then(({data})=> data.response)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getAdditionalFields: (context, payload) => {
            const url = `${bankApi}AdditonalData/getbyids?userId=${payload.userId}&BankId=${payload.bankId}`;
            return axios.get(url)
                .then(({ data }) => {
                    if (Array.isArray(data) && data.length > 0) {
                        return data[0];
                    } else {
                        console.warn("No additional data found for userId:", payload.userId, "bankId:", payload.bankId);
                        return null;
                    }
                })
                .catch(err => {
                    errorHandler.tomcatError(err, "Failed to fetch additional data.");
                    return null;
                });
        },

        getAgentByID : (context , agentID) =>{
            return axios.get(bankApi+`kazangAgents/getAgentByID?kazangID=`+agentID)
                .then(({data})=> data.response)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getPhotoByID : (context , imageID) =>{
            if (!imageID) return null;
            return axios.get(bankApi+`signup/image?id=`+imageID)
                .then(({data})=> data.response.image)
        },

        approveRequest : (context , headerID) =>{
            let userID = Storage.getAgentID();
            let object ={
                aprovedUser : userID,
                idAproved : headerID,
            }
            return axios.post(bankApi+`signup/ApproveUser`,object)
                .then(()=> {
                    context.dispatch(`getRequestCounts`)
                    responses.showSuccess(`Request Approved`)
                }).catch(err=>errorHandler.tomcatError(err))
        },
        approveKazangAgent : (context , headerID) =>{
            let userID = Storage.getAgentID();
            let object ={
                aprovedUser : userID,
                idAproved : headerID,
            }
            return axios.post(bankApi+`signup/approveKazangAgent`,object)
                .then(()=> {
                    context.dispatch(`getRequestCounts`)
                    responses.showSuccess(`Request Approved`)
                }).catch(err=>errorHandler.tomcatError(err))
        },

        declineRequest : (context , payload) =>{
            let userID = Storage.getAgentID();
            payload = {
                declinedUser : userID,
                ...payload
            }
            return axios.post(bankApi+`signup/DeclineUser`,payload)
                .then(()=>{
                    context.dispatch(`getRequestCounts`)
                    return true;
                })
                .catch(err=>errorHandler.tomcatError(err))
        },

        declineKazangAgent : (context , payload) =>{
            let userID = Storage.getAgentID();
            payload = {
                declinedUser : userID,
                ...payload
            }
            return axios.post(bankApi+`signup/declineKazangAgent`,payload)
                .then(()=>context.dispatch(`getRequestCounts`))
                .catch(err=>errorHandler.tomcatError(err))
        },
    },
}
